import * as React from 'react';
import { translate } from 'components/translate-hoc';
import { DateInputComponent, DateFormats } from 'react-controlled-date-input';

import { getDateAnalytics } from 'modules/additional-info-common/analytics.utils';
import { translateToEnglish } from 'utils/localization';
import { ICommonFieldProps } from './fields.types';

type ddmmyyyy = 'DD/MM/YYYY';
type mmddyyyy = 'MM/DD/YYYY';

const EN_US: string = 'en-US';

const DATE_STRING_PLACEHOLDER: string = '0';
const MAX_YEAR_STRING_LENGTH: number = 4;
const MAX_DAY_MONTH_STRING_LENGTH: number = 2;

interface IDateFieldState {
    format: ddmmyyyy | mmddyyyy;
}

export class DateField extends React.Component<ICommonFieldProps, IDateFieldState> {
    public static getDerivedStateFromProps(nextProps: ICommonFieldProps) {
        return {
            format: nextProps.activeLanguageCode === EN_US ? DateFormats.MMDDYYYY : DateFormats.DDMMYYYY
        };
    }

    constructor(props: ICommonFieldProps) {
        super(props);

        this.state = {
            format: DateFormats.MMDDYYYY
        };
    }

    private onChange(year: string | number, month: string | number, date: string | number): void {
        // @ts-ignore
        // TODO: remove ignore once issue with typings is resolved:
        // https://github.com/final-form/react-final-form/issues/441
        this.props.input.onChange(`${year}-${month}-${date}`);
    }

    private handleClick = (): void => {
        const { dangerouslyTranslateWithHTML: translateKey } = this.props;
        const englishTranslation = translateToEnglish(translateKey, this.getLabelKey());

        const eventData = getDateAnalytics(englishTranslation);
        this.props.onSendAnalyticsData(eventData);
    };

    private handleDesktopInputChange = (year: string, month: string, date: string): void => {
        const correctYear = year ? year.padStart(MAX_YEAR_STRING_LENGTH, DATE_STRING_PLACEHOLDER) : NaN;
        const correctDate = date ? date.padStart(MAX_DAY_MONTH_STRING_LENGTH, DATE_STRING_PLACEHOLDER) : NaN;
        const correctMonth = month ? month.padStart(MAX_DAY_MONTH_STRING_LENGTH, DATE_STRING_PLACEHOLDER) : NaN;

        this.onChange(correctYear, correctMonth, correctDate);
    };

    private handleMobileInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const dateObj = new Date(event.target.value);

        const year = dateObj.getFullYear();
        const date = dateObj.getDate();
        const month = dateObj.getMonth() + 1;

        this.onChange(year, month, date);
    };

    private getLabelKey(): string {
        const { translatePrefix, input } = this.props;
        return `${translatePrefix}${input.name}`;
    }

    public render(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey, translatePrefix, meta } = this.props;
        const labelText = translateKey(this.getLabelKey());
        const isWarning = meta.error && meta.submitFailed;
        const errorMessage = isWarning ? translateKey(`${translatePrefix}${meta.error.message}`) : '';

        /**
         * Because we use DateInputComponent instead of html input element we cant
         * add onBlur or onFocus event listeners to the input, because of this some flags
         * in meta object of props can be broken, for example, touched flag.
         */
        return (
            <div className="sitegen-date-picker">
                <div className="sitegen-date-picker__label">{labelText}</div>
                <div className="sitegen-date-picker__container">
                    <div className="sitegen-date-picker__container_desktop" onClick={this.handleClick}>
                        <DateInputComponent
                            onChange={this.handleDesktopInputChange}
                            dateFormat={this.state.format}
                        />
                    </div>
                    <div className="sitegen-date-picker__container_mobile" onClick={this.handleClick}>
                        <input type="date"
                            onChange={this.handleMobileInputChange} />
                    </div>
                    <div className="sitegen-date-picker__error">{errorMessage}</div>
                </div>
            </div>
        );
    }
}

export default translate()(DateField);
